import { render, staticRenderFns } from "./CollegeList.vue?vue&type=template&id=78d70b68&"
import script from "./CollegeList.vue?vue&type=script&lang=js&"
export * from "./CollegeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports